import axios from "axios";
import {formDataHandler} from "@/services/form";
const errorsHandler = require("@/services/errors")

//Change This
const module = 'cancellation-reason'

const state = {

}

const getters = {

}

const actions = {
    index : async (context,payload) => {

        let url = `api/v1/${module}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`, {
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data.result

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    store : async (context,payload) => {

        let url = `api/v1/${module}/store/`;

        let formData = await formDataHandler(payload)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`, formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "multipart/form-data",
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    edit : async (context,payload) => {

        let url = `api/v1/${module}/${payload.id}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    update : async (context,payload) => {

        let url = `api/v1/${module}/update/${payload.id}`;

        let formData = await formDataHandler(payload.item)

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    delete : async (context,payload) => {

        let url = `api/v1/${module}/delete/${payload.id}`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,{},{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    massDelete : async (context,payload) => {

        let url = `api/v1/${module}/mass-delete`;

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,payload,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    }
}

const mutations = {

}


export default {
    namespaced : true,
    state,
    mutations,
    getters,
    actions
}

